module.exports = __webpack_public_path__ + "nocode.png?9bf8cedec45db72e560af7b4f00ca4cc";